module.exports = __webpack_public_path__ + "img/weddings_14_V.498e4d45.webp";